/**************************************************
 * Nombre:       Seccion_Config_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {useFormulario} from "../../Modulo_formularios/Hooks/useFormulario";
import Formulario_Config_Crm from "../../Modulo_CRM/Formularios/Formulario_Config_Crm";
import {Check} from '@mui/icons-material'
import {useCargador} from "../../Modulo_Cargador/Hooks/useCargador";
import logo from "../../Recursos/logo_redondo.svg";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {guardarFechaAct} from "../../Servicios/BD/Actualizadores/guardarFechaAct";
import {usuarioContext} from "../../App";


const Seccion_Config_Crm = () => {
    const cData = useContext(usuarioContext)
    const {props, obtenerEntidad, setEntidad} = useFormulario({valoresDefecto: {}})
    const {Avisos, Cargador, nuevoAviso, terminar, iniciarCarga} = useCargador({
        logoRedondo: logo,
        direccion: 'center'
        //  funcionUno: realizado,
        // funcionDos: cerrar
    })


    const guardar = async () => {

        let entidad = await obtenerEntidad()
        iniciarCarga()
        let dox = await guardarDoc('configCrm', entidad)

        await guardarFechaAct('configCrm')
        if (dox.res) {
            terminar({aviso: 'Datos subidos con exito'})
        } else {
            terminar({aviso: 'Algo sali mal, por favor intetalo nuevamente', variante: 'error'})
        }
    }


    useEffect(() => {

        if (cData.configCrm[0]) {
            setEntidad(cData.configCrm[0])
        }

    }, [cData]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px'}}
                spacing={3}
            >

                <Cargador/>

                <Avisos/>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Typography sx={{fontSize: 32, fontWeight: 600}}>Configuracion Crm</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-end'}}>
                    <Button
                        onClick={() => guardar()}
                        startIcon={<Check/>}
                    >Guardar Cambios</Button>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start'}}>
                    <Formulario_Config_Crm props={props}/>
                </Grid>

            </Grid>

        </Grid>

    )

}
export default Seccion_Config_Crm
